import BottomDialog from '../../../../../../components/bottomDialog';
import CompleteStamp from '../../complete';

const RestDayBottomDialog = ({
  dialogRef,
  closeBottomDialog,
  takeRest,
  isSelectedWorkoutDone,
  challenge,
  selectedWorkout,
  selectedDay,
}) => {
  return (
    <BottomDialog
      dialogRef={dialogRef}
      closeDialog={closeBottomDialog}
    >
      <div className='flex flex-col items-center gap-2'>
        {isSelectedWorkoutDone ? (
          <CompleteStamp
            challengeTitle={challenge.title}
            workoutTitle={selectedWorkout?.title ?? ''}
            selectedDay={selectedDay}
          />
        ) : (
          <button
            className='border rounded-xl w-full py-2 bg-blue-500 text-blue-600 bg-opacity-20 border-blue-500 border-opacity-60'
            onClick={takeRest}
          >
            Take a Rest!
          </button>
        )}
        <button
          className='border rounded-xl w-full py-2 mt-4'
          onClick={closeBottomDialog}
        >
          Cancel
        </button>
      </div>
    </BottomDialog>
  );
};

export default RestDayBottomDialog;
